import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Home from "./pages/home/index";
import reportWebVitals from "./reportWebVitals";
import { createHashRouter, RouterProvider } from "react-router-dom";

import { Web3ReactProvider } from "@web3-react/core";
import { Web3Provider } from "@ethersproject/providers";
import Web3 from "web3";
import { network } from "./config";
// import AdminHome from "./pages/admin";

const router = createHashRouter([
  {
    path: "/",
    element: <Home></Home>,
  },
  // {
  //   path: "/ad",
  //   element: <AdminHome></AdminHome>,
  // },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
async function switchNetwork(id: number) {
  try {
    await window.ethereum.request({
      method: "wallet_switchEthereumChain",
      params: [
        {
          chainId: "0x" + id.toString(16),
        },
      ],
    });
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
}
function MyWeb3Provider(network: number, provider: any) {
  let web3: Web3 | null = null;

  if (window.ethereum) {
    web3 = new Web3(window.ethereum);
    window.ethereum
      .request({ method: "net_version" })
      .then((networkId: string) => {
        if (networkId !== network.toString()) {
          switchNetwork(network);
        }
      });
  }

  return web3 ? new Web3Provider(provider, network) : null;
}
function getLibrary(provider: any) {
  return MyWeb3Provider(network, provider);
  // return new Web3Provider(provider);
}
root.render(
  <React.StrictMode>
    {/* <ReactSound url={BGM} playStatus={'PLAYING'} loop={true} autoLoad></ReactSound> */}
    <Web3ReactProvider getLibrary={getLibrary}>
      <RouterProvider router={router} />
    </Web3ReactProvider>
    <div className="app-version">v2.0.1</div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
